class Product {
  constructor() {
    this.initSlider();
    this.initCaseSlider();
  }

  initSlider() {
    const sliders = document.querySelectorAll('.js-product-slider');

    if (!sliders.length || typeof Swiper === 'undefined') {
      return;
    }

    sliders.forEach((el) => {
      const block = el.closest('.s-product-block');
      if (!block) {
        return;
      }

      const prevBtn = block.querySelector('.js-product-slider-prev');
      const nextBtn = block.querySelector('.js-product-slider-next');
      const meterBar = block.querySelector('.js-product-slider-meter span');

      const slideCount = el.querySelectorAll('.swiper-slide').length;

      const updateMeter = (swiper) => {
        if (!meterBar) {
          return;
        }
        const current = swiper.realIndex + 1;
        meterBar.style.width = `${(current / slideCount) * 100}%`;
      };

      const swiper = new Swiper(el, {
        slidesPerView: 1.35,
        spaceBetween: 12,
        watchOverflow: false,
        speed: 600,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.36,
            spaceBetween: 20,
          },
        },
        on: {
          init(swiperInstance) {
            updateMeter(swiperInstance);
          },
          slideChange(swiperInstance) {
            updateMeter(swiperInstance);
          },
        },
      });
    });
  }

  initCaseSlider() {
    const el = document.querySelector('.js-product-case-splide');

    if (!el || typeof Splide === 'undefined') {
      return;
    }

    const section = el.closest('.s-product-case');
    const prevBtn = section?.querySelector('.js-product-case-prev');
    const nextBtn = section?.querySelector('.js-product-case-next');
    const meterBar = section?.querySelector('.js-product-case-meter span');

    const splide = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      gap: '1.6rem',
      focus: 'center',
      arrows: false,
      pagination: false,
      trimSpace: false,
      breakpoints: {
        768: {
          gap: '2rem',
        },
      },
    });

    const updateMeter = () => {
      if (!meterBar) {
        return;
      }

      const total = splide.length;
      if (total <= 0) {
        return;
      }

      const current = splide.index + 1;
      meterBar.style.width = `${(current / total) * 100}%`;
    };

    splide.on('mounted move', updateMeter);
    splide.mount();

    prevBtn?.addEventListener('click', () => splide.go('<'));
    nextBtn?.addEventListener('click', () => splide.go('>'));
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		gsap.set('.s-mv', {
			autoAlpha: 1,
		});
		
		ScrollTrigger.create({
			trigger: '.s-bg-white',
			start: 'center center',
			onEnter: () => {
				gsap.set('.s-mv', {
					autoAlpha: 0,
				});
			},
			onLeaveBack: () => {
				gsap.set('.s-mv', {
					autoAlpha: 1,
				});
			},
		});

		const mvCopy = document.querySelector('.js-mv-copy');
		const header = document.querySelector('.js-header');
		const mvScroll = document.querySelector('.js-mv-scroll');
	
		if (!mvCopy) return;
	
		// =========================
		// 初期状態
		// =========================
		gsap.set($('.p-top'), {
			opacity: 0,
		});
		gsap.set(mvCopy, {
			opacity: 0,
			x: '-3rem',
			filter: 'blur(1.5rem)',
			clipPath: 'inset(0 100% 0 0)',
		});
	
		gsap.set([header, mvScroll], {
			opacity: 0,
		});
	
		// =========================
		// アニメーション
		// =========================
		const tl = gsap.timeline();
	
		tl.to($('.p-top'), {
			opacity: 1,
			duration: 0.7,
			ease: 'power2.out',
		});
		tl.to(mvCopy, {
			opacity: 1,
			x: 0,
			filter: 'blur(0rem)',
			clipPath: 'inset(0 0% 0 0)',
			duration: 1.5,
			ease: 'power3.out',
		})
		.to([header, mvScroll], {
			opacity: 1,
			duration: 0.7,
			ease: 'power2.out',
		}, '+=0.05');

		const caseSplideEl = document.querySelector('.js-case-splide');

		if (caseSplideEl) {
			const progressBar = document.querySelector('.s-case-head__nav .line span');
			const prevBtn = document.querySelector('.js-case-prev');
			const nextBtn = document.querySelector('.js-case-next');

			const splide = new Splide(caseSplideEl, {
				type: 'loop',
				autoWidth: true,
				gap: '1.6rem',
				focus: 'center',
				arrows: false,
				pagination: false,
				trimSpace: false,
				breakpoints: {
					768: {
						gap: '2rem',
					},
				},
			});

			const updateProgress = () => {
				if (!progressBar) return;

				const total = splide.length;
				if (total <= 0) return;

				const current = splide.index + 1;
				progressBar.style.width = `${(current / total) * 100}%`;
			};

			splide.on('mounted move', updateProgress);
			splide.mount();

			prevBtn?.addEventListener('click', () => splide.go('<'));
			nextBtn?.addEventListener('click', () => splide.go('>'));
		}
	
	
	}
}
class ContactForm {
  constructor() {
    this.root = document.querySelector('.p-contact .wpcf7-form') || document.querySelector('.c-contact-form');
    if (!this.root) return;

    this.form = this.root.closest('form') || this.root;
    this.careerValue = (window.arkContact && window.arkContact.careerCategory) || 'キャリア採用';
    this.applyQueryCategory();
    this.bindCategory();
    this.bindFileFields();
    this.syncMode();
  }

  bindFileFields() {
    this.form.querySelectorAll('.c-contact-form__field--file').forEach((field) => {
      const input = field.querySelector('input[type="file"]');
      const nameEl = field.querySelector('.js-contact-file-name');
      if (!input || !nameEl) return;

      const syncName = () => {
        nameEl.textContent = input.files && input.files[0] ? input.files[0].name : '';
      };
      input.addEventListener('change', syncName);
      syncName();
    });
  }

  applyQueryCategory() {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');
    if (!category) return;
    const target = this.form.querySelector(`input[name="inquiry-category"][value="${CSS.escape(category)}"]`);
    if (target) {
      target.checked = true;
    }
  }

  getCategory() {
    const checked = this.form.querySelector('input[name="inquiry-category"]:checked');
    return checked ? checked.value : '';
  }

  isCareer() {
    return this.getCategory() === this.careerValue;
  }

  syncMode() {
    const career = this.isCareer();
    this.form.querySelectorAll('.js-contact-fields--general').forEach((el) => {
      el.hidden = career;
      el.querySelectorAll('input, textarea, select').forEach((input) => {
        if (career) {
          input.setAttribute('data-ark-disabled', '1');
        } else {
          input.removeAttribute('data-ark-disabled');
        }
      });
    });
    this.form.querySelectorAll('.js-contact-fields--career').forEach((el) => {
      el.hidden = !career;
      el.querySelectorAll('input, textarea, select').forEach((input) => {
        if (!career) {
          input.setAttribute('data-ark-disabled', '1');
        } else {
          input.removeAttribute('data-ark-disabled');
        }
      });
    });
  }

  bindCategory() {
    this.form.querySelectorAll('input[name="inquiry-category"]').forEach((input) => {
      input.addEventListener('change', () => this.syncMode());
    });
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {		
    var windowWidth = $(window).width();
    var windowSm = 768;
		if (windowWidth <= windowSm) {
			$('.js-h-content a').on('click', function() {
				$('html').removeClass('is-open');
				scrollBan();
			});
		} else {
			$('.js-mega-trigger').hover(function() {
				$(this).addClass('is-active');
				$(this).next('.js-mega-content').addClass('is-active');
			}, function() {
				$(this).removeClass('is-active'); 
				$(this).next('.js-mega-content').removeClass('is-active');
			});
		
			$('.js-mega-content').hover(function() {
				$(this).addClass('is-active');
				$(this).closest('.js-mega-trigger').addClass('is-active');
				$(this).closest('.js-mega-trigger').find('.js-mega-trigger-plus').addClass('is-active');
			}, function() {
				$(this).removeClass('is-active');
				$(this).closest('.js-mega-trigger').removeClass('is-active');
				$(this).closest('.js-mega-trigger').find('.js-mega-trigger-plus').removeClass('is-active');
			});
		}
    
    $(window).scroll(function () {
      if (!$('html').hasClass('is-top')) {
        return;
      }
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    // スマホメニュー内のクリック（言語切替はそのまま遷移）
    $('.js-header').find('a').not('.c-header-lang__item').click(function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    $('.c-header-lang__item').on('click', function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    let scrollTop = 0;

    // html固定スクロール禁止/解除（引数なし=toggle / true=lock / false=unlock）
    const scrollBan = (() => {
      const html = document.documentElement; // $('html')[0] と同じ
      let locked = false;
      let scrollTop = 0;

      const lock = () => {
        if (locked) return;
        locked = true;

        scrollTop = window.scrollY || 0;

        // 現在位置を固定
        html.style.top = `${-scrollTop}px`;
        html.classList.add("is-hidden");
      };

      const unlock = () => {
        if (!locked && !html.classList.contains("is-hidden")) return;
        locked = false;

        // scroll-behavior を一時的に auto にして瞬間復帰
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";

        html.style.top = "";
        html.classList.remove("is-hidden");

        window.scrollTo(0, scrollTop);

        // 次フレームで元に戻す（0ms setTimeout より安全）
        requestAnimationFrame(() => {
          html.style.scrollBehavior = prevScrollBehavior;
        });
      };

      // state: true=lock / false=unlock / undefined=toggle
      return (state) => {
        if (typeof state === "boolean") {
          state ? lock() : unlock();
          return locked;
        }
        locked ? unlock() : lock();
        return locked;
      };
    })();
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class ScrollMv {
  constructor() {
    this.init();
  }

  init() {
    const scrollIcons = document.querySelectorAll('.js-c-mv-scroll, .js-mv-scroll');

    if (!scrollIcons.length) {
      return;
    }

    scrollIcons.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        const href = icon.getAttribute('href');
        let target = href && href.startsWith('#')
          ? document.querySelector(href)
          : null;

        if (!target) {
          const mv = icon.closest('.c-mv');
          target = mv?.nextElementSibling;
        }

        if (!target) {
          return;
        }

        e.preventDefault();

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth';

        target.scrollIntoView({ behavior, block: 'start' });
      });
    });
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		if($(".js-madori-thum").length > 0){
			$('.js-madori-thum li').on('click', function () {

				const imgSrc = $(this).find('img').attr('src');
		
				// メイン画像変更
				$('.js-madori-main img').attr('src', imgSrc);
		
				// active切替
				$('.js-madori-thum li').removeClass('is-active');
				$(this).addClass('is-active');
		
			});
		}

		// if($(".js-tab-content").length > 0){
		// 	$(".js-tab-content").each(function(){

		// 		const $wrap = $(this);
		// 		const $tabs = $wrap.prev().find(".js-tab-item");
		// 		const $contents = $wrap.children("div");
			
		// 		$tabs.removeClass("is-active").first().addClass("is-active");
		// 		$contents.hide().first().show();
			
		// 		$tabs.on("click", function(){			
		// 			const index = $(this).index();			
		// 			$tabs.removeClass("is-active");
		// 			$(this).addClass("is-active");
			
		// 			$contents.hide().eq(index).show();
			
		// 		});
			
		// 	});
		// }

		if($(".js-tab").length > 0){
			$(".js-tab").each(function(){

				const $wrap = $(this);
				const $tabs = $wrap.find(".js-tab-item");
				const $contents = $wrap.find(".js-tab-content");
			
				$tabs.removeClass("is-active").first().addClass("is-active");
				$contents.hide().first().show();
			
				$tabs.on("click", function(){

					const index = $tabs.index(this);
				
					$tabs.removeClass("is-active");
					$(this).addClass("is-active");
				
					$wrap.find(".js-tab-content").hide();
					$wrap.find(".js-tab-content").eq(index).show();
				
				});
			
			});
		}
	}
}


(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let headerMenu = new HeaderMenu('js-header');
  new ScrollMv();
  let tab = new Tab('js-tab');
  if ($('html').hasClass('is-top')) {
    new Top('p-top');
  }
  if ($('.p-product').length) {
    new Product();
  }
  // 他モジュールの例外で止まらないよう、お問い合わせ初期化は独立させる
  try {
    if ($('.p-contact').length) {
      new ContactForm();
    }
  } catch (err) {
    if (window.console && console.error) {
      console.error('[ContactForm]', err);
    }
  }
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});